import { render, staticRenderFns } from "./IOUAndCertificates.vue?vue&type=template&id=29eefcf6&scoped=true&"
import script from "./IOUAndCertificates.vue?vue&type=script&lang=ts&"
export * from "./IOUAndCertificates.vue?vue&type=script&lang=ts&"
import style0 from "./IOUAndCertificates.vue?vue&type=style&index=0&id=29eefcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eefcf6",
  null
  
)

export default component.exports